import config, {axiosConfig} from "../config";
import {default as axios} from "./axiosConfig";
import {SignQuotationResponse} from "./model/identification";
import * as log from "../utils/log";
import {ProductType} from "./model/common";
import {getFuncMod} from "../utils/log";
import {getTypePath} from "./common";

export async function sendIdentificationCode(quotationId: string, type: ProductType) {
	const date = new Date();
	let data: any
	await axios.post(`${config.API_URL}/${getTypePath(type)}/send-identification-code/${quotationId}`, {}, axiosConfig)
		.then(resp => {
			data = resp.data
			log.sendLog(date, getFuncMod(type), 'INFO',"SEND_IDENTIFICATION_CODE",
				[{sendIdentificationCode: resp, quotationId: quotationId}], '');
		})
		.catch(err => {
			log.sendLog(date, getFuncMod(type), 'INFO',"SEND_IDENTIFICATION_CODE_FAILED_NO_RESPONSE",
				[{quotationId: quotationId}], err.response);
		})

	return data;
}

const getFinalPageUrl = (type: ProductType, quotationId: string) => {
	switch (type) {
		case ProductType.EMTPL:
			return `${config.verification.successfulQuotationURL}/${quotationId}`;
		case ProductType.TRAVEL:
			return `${config.verification.travelSuccessfulQuotationURL}/${quotationId}`;
		case ProductType.GREEN_CARD:
			return `${config.verification.greenSuccessfulQuotationURL}/${quotationId}`;
	}
}

export async function signQuotation(quotationId: string, step: string, otpCode: string, type: ProductType) {
	const date = new Date();

	return axios.post<SignQuotationResponse>(`${config.API_URL}/${getTypePath(type)}/sign-quotation/${quotationId}?currentStep=${step}`,
		{
			"otpCode": otpCode,
			finalPageUrl: getFinalPageUrl(type, quotationId)
		}, axiosConfig)
		.then(response => {
			log.sendLog(date, getFuncMod(type), 'INFO',"SIGN_QUOTATION",
				[{SignQuotationResponse: response, step: step}], '');
			return response.data;
		})
		.catch( error => {
			log.sendLog(date, getFuncMod(type), 'INFO',"SIGN_QUOTATION_FAILED_NO_RESPONSE",
				[{step: step}], error.response);
			const data = error.response?.data || {};
			data.error = true;
			return data;
	});
}

export async function getQuotationPaymentPageUrl(quotationId: string, type: ProductType) {
	const {data} = await axios.post<{billURL: string}>(`${config.API_URL}/${getTypePath(type)}/quotation/payment-page-url/${quotationId}`,
		{
			"finalPageUrl": getFinalPageUrl(type, quotationId)
		}, axiosConfig
	);
	return data.billURL;
}